export default "__VITE_ASSET__vBfzSIuq__"